/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Height_LongInputs */

const en_us2_intake_why_height_long = /** @type {(inputs: Intake_Why_Height_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With weight, it sizes the first loads and the lever lengths some exercises assume.`)
};

const pt_br2_intake_why_height_long = /** @type {(inputs: Intake_Why_Height_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com o peso, dimensiona as primeiras cargas e as alavancas que alguns exercícios assumem.`)
};

const es_419_intake_why_height_long = /** @type {(inputs: Intake_Why_Height_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junto con el peso, dimensiona las primeras cargas y las palancas que algunos ejercicios suponen.`)
};

const pt_pt2_intake_why_height_long = /** @type {(inputs: Intake_Why_Height_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com o peso, dimensiona as primeiras cargas e as alavancas que alguns exercícios pressupõem.`)
};

const fr_fr2_intake_why_height_long = /** @type {(inputs: Intake_Why_Height_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec le poids, elle sert à calibrer les premières charges et les leviers que certains exercices supposent.`)
};

const de_de2_intake_why_height_long = /** @type {(inputs: Intake_Why_Height_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammen mit dem Gewicht bestimmt sie die ersten Lasten und die Hebellängen, von denen manche Übungen ausgehen.`)
};

const it_it2_intake_why_height_long = /** @type {(inputs: Intake_Why_Height_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insieme al peso, dimensiona i primi carichi e le leve che alcuni esercizi presuppongono.`)
};

/**
* | output |
* | --- |
* | "With weight, it sizes the first loads and the lever lengths some exercises assume." |
*
* @param {Intake_Why_Height_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_height_long = /** @type {((inputs?: Intake_Why_Height_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Height_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_height_long(inputs)
	if (locale === "es-419") return es_419_intake_why_height_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_height_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_height_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_height_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_height_long(inputs)
	return en_us2_intake_why_height_long(inputs)
});
export { intake_why_height_long as "intake.why.height.long" }